export default __webpack_public_path__ + "static/aikido-celje-stara-cb66f41b35b440c27e9dd9ad8955bb71.jpg";